import React from "react";
import styled from "styled-components";
import SpeakerMenu from "./SpeakerMenu";
import EnhancedFormatting from "./EnhancedFormatting/index";
import withTTS from "./SpeakerMenu/withTTS";
import { TOOLBAR_PADDING } from "./consts";

const BUTTON_SPACING = 12;
const ToolBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 ${TOOLBAR_PADDING - BUTTON_SPACING}px;
  height: 100%;
  & > * {
    margin: 0 ${BUTTON_SPACING}px;
    pointer-events: auto;
  }
`;

const TTSMenu = withTTS(SpeakerMenu);

const ReaderToolBar = () => {
  return (
    <ToolBar>
      <TTSMenu />
      <EnhancedFormatting />
    </ToolBar>
  );
};

export default ReaderToolBar;
